lmApp
  .service('ProfileService', ['$q', '$rootScope', function ($q, $rootScope) {

    var service = {};

    service.UpdateOperatorsPlatform = function (data) {
      var deferred = $q.defer();

      var platformData = {
        platform_id: data.id
      };

      if (data.app_url) platformData.app_url = data.app_url;
      if (data.logo_url) platformData.logo_url = data.logo_url;

      lh.common.request.post('cloud/mgmt/operator/platform/update', platformData)
        .then(function (response) {
          deferred.resolve();
        }, function (reason) {
          reason.url = 'cloud/mgmt/operator/platform/update';
          reason.data = platformData;
          deferred.reject(reason);
        });

      return deferred.promise;
    };

    service.UpdateOperatorsData = function (profileData) {
      var deferred = $q.defer();

      var data = {
        title: profileData.title,
        description: profileData.description
        //offer_text: profileData.userAgreement,
        //email_template: JSON.stringify(profileData.email_template),
        //sms_confirmation_text: profileData.sms_text,
        //support_phone: profileData.support_phone,
        //support_email: profileData.support_email
      };

      lh.common.request.post('cloud/mgmt/operator/update', data)
        .then(function (response) {
          deferred.resolve();
        }, function (reason) {
          reason.url = 'cloud/mgmt/operator/update';
          reason.data = data;
          deferred.reject(reason);
        });

      return deferred.promise;
    };

    service.UploadImage = function (file) {
      var deferred = $q.defer();

      var params = {
        Key: file.name,
        ContentType: file.type,
        ContentLength: file.size,
        Body: file,
        ACL: 'public-read'
      };
      $rootScope.aws.upload(params, function (err, data) {
        if (data && 'Location' in data) {
          deferred.resolve(data.Location);
          return;
        }

        if (err) {
          deferred.reject({
            url: 'aws3',
            message: err,
            data: params
          });
          return;
        }
      });

      return deferred.promise;
    };

    service.GetOperatorData = function () {
      var deferred = $q.defer();

      lh.common.request('cloud/mgmt/get_operator')
        .then(function (data) {
          deferred.resolve(data);
        }, function (reason) {
          reason.url = 'cloud/mgmt/get_operator';
          reason.data = 'GET';
          deferred.reject(reason);
        });

      return deferred.promise;
    };

    return service;
  }]);
